/* External dependencies */
import moment from 'moment';
import 'moment/locale/ru';

interface DateFormatProps {
  date: any;
}

export default function DateFormat({ date }: DateFormatProps) {
  const DATE_FORMAT: string = 'DD MMMM, YYYY';

  return moment.unix(date).format(DATE_FORMAT);
}
